// SOLIDOR project dataset — replace placeholder entries with real projects later.
// Every project: id, title, bilingual location/category/status/description, cover, gallery.

const u = (id, w = 1800) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMG = {
  concrete: "photo-1612090078171-9e1e933e2bcc",
  facade: "photo-1622396481322-3b83d186701b",
  interior: "photo-1724582586529-62622e50c0b3",
  villa: "photo-1565371557106-c2abcc6fb36a",
  office: "photo-1549791084-5f78368b208b",
  pool: "photo-1701856221387-9484068b030c",
  lounge: "photo-1760072513367-55182245e76c",
  timber: "photo-1757924461488-ef9ad0670978",
  workspace: "photo-1758957701419-2c6e266f7988",
};

export const HERO_IMAGE = u(IMG.concrete, 2400);

export const projects = [
  {
    id: "house-01",
    title: "House 01",
    category: { en: "Residential", tr: "Konut" },
    location: { en: "Bosphorus, Istanbul", tr: "Boğaziçi, İstanbul" },
    year: "2025",
    status: { en: "Completed", tr: "Tamamlandı" },
    cover: u(IMG.concrete),
    description: {
      en: "A monolithic concrete residence above the Bosphorus — raw mass balanced by precise openings that frame the strait.",
      tr: "Boğaz'ın üzerinde monolitik bir beton konut — ham kütle, boğazı çerçeveleyen hassas açıklıklarla dengeleniyor.",
    },
    gallery: [
      { type: "full", src: u(IMG.interior, 2200) },
      { type: "duo", left: u(IMG.timber, 1200), right: u(IMG.lounge, 1200) },
      { type: "full", src: u(IMG.facade, 2200) },
      { type: "duo", left: u(IMG.pool, 1200), right: u(IMG.concrete, 1200) },
    ],
  },
  {
    id: "residence-02",
    title: "Residence 02",
    category: { en: "Private Villa", tr: "Özel Villa" },
    location: { en: "Bodrum Peninsula", tr: "Bodrum Yarımadası" },
    year: "2024",
    status: { en: "Completed", tr: "Tamamlandı" },
    cover: u(IMG.facade),
    description: {
      en: "Terraced limestone volumes among olive groves, dissolving the boundary between inside and outside.",
      tr: "Zeytinlikler arasında teraslanmış kireçtaşı hacimler — iç ve dış mekân arasındaki sınır çözülüyor.",
    },
    gallery: [
      { type: "full", src: u(IMG.lounge, 2200) },
      { type: "duo", left: u(IMG.pool, 1200), right: u(IMG.villa, 1200) },
      { type: "full", src: u(IMG.interior, 2200) },
    ],
  },
  {
    id: "interior-01",
    title: "Interior 01",
    category: { en: "Interior Architecture", tr: "İç Mimarlık" },
    location: { en: "Nişantaşı, Istanbul", tr: "Nişantaşı, İstanbul" },
    year: "2025",
    status: { en: "Completed", tr: "Tamamlandı" },
    cover: u(IMG.interior),
    description: {
      en: "Travertine wall systems and timber craftsmanship reshape an urban penthouse into calm, light-filled rooms.",
      tr: "Traverten duvar sistemleri ve ahşap işçiliği, kentsel bir çatı katını sakin ve ışık dolu mekânlara dönüştürüyor.",
    },
    gallery: [
      { type: "full", src: u(IMG.timber, 2200) },
      { type: "duo", left: u(IMG.lounge, 1200), right: u(IMG.interior, 1200) },
      { type: "full", src: u(IMG.concrete, 2200) },
    ],
  },
  {
    id: "villa-03",
    title: "Villa 03",
    category: { en: "Residential", tr: "Konut" },
    location: { en: "Kemerburgaz, Istanbul", tr: "Kemerburgaz, İstanbul" },
    year: "2024",
    status: { en: "In Progress", tr: "Devam Ediyor" },
    cover: u(IMG.villa),
    description: {
      en: "A forest-side concrete structure organised around light courtyards, where shadow is a building material.",
      tr: "Ormanın yanında, ışık avluları etrafında örgütlenen beton bir yapı — gölge burada bir yapı malzemesi.",
    },
    gallery: [
      { type: "full", src: u(IMG.pool, 2200) },
      { type: "duo", left: u(IMG.villa, 1200), right: u(IMG.timber, 1200) },
      { type: "full", src: u(IMG.facade, 2200) },
    ],
  },
  {
    id: "workspace-01",
    title: "Workspace 01",
    category: { en: "Commercial", tr: "Ticari" },
    location: { en: "Levent, Istanbul", tr: "Levent, İstanbul" },
    year: "2023",
    status: { en: "Completed", tr: "Tamamlandı" },
    cover: u(IMG.office),
    description: {
      en: "A studio headquarters defined by an exposed structural grid and a disciplined material palette.",
      tr: "Açıkta bırakılan strüktür ızgarası ve disiplinli malzeme paletiyle tanımlanan bir stüdyo genel merkezi.",
    },
    gallery: [
      { type: "full", src: u(IMG.workspace, 2200) },
      { type: "duo", left: u(IMG.office, 1200), right: u(IMG.interior, 1200) },
      { type: "full", src: u(IMG.timber, 2200) },
    ],
  },
  {
    id: "hospitality-01",
    title: "Hospitality 01",
    category: { en: "Hospitality", tr: "Konaklama" },
    location: { en: "Urla, Izmir", tr: "Urla, İzmir" },
    year: "2025",
    status: { en: "Under Construction", tr: "İnşaat Aşamasında" },
    cover: u(IMG.pool),
    description: {
      en: "A boutique vineyard hotel embedded in Aegean topography, built with rammed earth and shadow.",
      tr: "Ege topografyasına gömülü butik bir bağ oteli — kerpiç duvarlar ve gölgeyle inşa ediliyor.",
    },
    gallery: [
      { type: "full", src: u(IMG.concrete, 2200) },
      { type: "duo", left: u(IMG.pool, 1200), right: u(IMG.lounge, 1200) },
      { type: "full", src: u(IMG.villa, 2200) },
    ],
  },
];

export const getProject = (id) => projects.find((p) => p.id === id);
export const getNextProject = (id) => {
  const i = projects.findIndex((p) => p.id === id);
  return projects[(i + 1) % projects.length];
};
